import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { getPlaceList } from "../store/slices/places";
import { addplacewiseHotel } from "../store/slices/placewisehotel";

const AddPlaceHotel = () => {
  const [place, setPlace] = useState();
  const [hotelName, sethotelName] = useState();
  const [placeList, setplaceList] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    const validationErrors = { ...errors };

    if (name === "place") {
      setPlace(value);
      validationErrors.place =
        value.trim() === "" ? "Please select a place" : "";
    }

    if (name === "hotelName") {
      sethotelName(value);
      validationErrors.hotelName =
        value.trim() === "" ? "Please enter hotel name" : "";
    }

    setErrors(validationErrors);
  };

  const validateForm = () => {
    let newErrors = {};

    // Places Validation
    if (!place || place.trim() === "") {
      newErrors.place = "Please select a place";
    }

    if (!hotelName || hotelName.trim() === "") {
      newErrors.hotelName = "Please enter hotel name";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const addPackage = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      console.log("Validation failed, please fix the errors.", errors);
      return;
    }

    setIsDisabled(true);
    setTimeout(() => setIsDisabled(false), 3000);

    const item = {
      hotelName,
      place,
    };

    try {
      await dispatch(addplacewiseHotel(item)).unwrap();
      alert("Hotel added successfully!");
      navigate("/admin/placewise-hotel");
    } catch (error) {
      alert(error);
      setIsDisabled(false);
    }
  };

  function cancel(e) {
    navigate(-1);
  }

  React.useEffect(() => {
    dispatch(getPlaceList())
      .unwrap()
      .then((data) => {
        setplaceList(data?.placesData || []);
      })
      .catch((err) => {
        console.error("Error fetching places:", err.message);
      });
  }, [dispatch]);

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Add Place Wise Hotel</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/placewise-hotel"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Place Wise Hotel List
            </Link>
          </li>
          <li> &gt; </li>
          <li className="fw-medium">Add Place Wise Hotel</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <form autoComplete="off" onSubmit={addPackage}>
            <div className="row mb-40">
              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Place<span className="text-danger">*</span>
                </label>
                <select
                  name="place"
                  value={place}
                  onChange={handleChange}
                  className={`form-control ${errors.place ? "is-invalid" : ""}`}
                >
                  <option value="Corbyn's Cove">Corbyn's Cove</option>
                  <option value="Prothrapur">Prothrapur</option>
                  <option value="Austinabad">Austinabad</option>
                  <option value="Bird-Line">Bird-Line</option>
                  <option value="Burmanallah">Burmanallah</option>
                  <option value="Chidiya Tapu">Chidiya Tapu</option>
                  <option value="Garacharama">Garacharama</option>
                  <option value="Sippighat">Sippighat</option>
                  <option value="Wandoor">Wandoor</option>
                  <option value="Herbertabad">Herbertabad</option>
                  <option value="Vijaynagar Beach, Havelock">
                    Vijaynagar Beach, Havelock
                  </option>
                  <option value="Kalapathar Beach">
                    Kalapathar Beach, Havelock
                  </option>
                  <option value="Sitapur, Neil Island">
                    Sitapur, Neil Island
                  </option>
                </select>
                {errors.place && (
                  <div className="text-danger mt-2">{errors.place}</div>
                )}
              </div>
              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Hotel Name<span className="text-danger">*</span>
                </label>
                <input
                  name="hotelName"
                  value={hotelName}
                  onChange={handleChange}
                  placeholder="Hotel Name"
                  className={`form-control ${
                    errors.hotelName ? "is-invalid" : ""
                  }`}
                />

                {errors.hotelName && (
                  <div className="text-danger mt-2">{errors.hotelName}</div>
                )}
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-center gap-3">
              <button
                type="button"
                onClick={cancel}
                className="btn btn-outline-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isDisabled}
                className="btn btn-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddPlaceHotel;
